import { createSelector } from '@reduxjs/toolkit';

const NAME = 'service'

export const list = state => state[NAME].list

export const selected = state => state[NAME].selected

export const isLoading = state => state[NAME].isLoading

export const item = createSelector(
  list,
  selected,
  (_list, _selected) =>  _list.find(x => x.value === _selected)
)